var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLockBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2916 17.25H36.4166V13.4166C36.4166 6.01863 30.3981 0 23 0C15.6019 0 9.58336 6.01863 9.58336 13.4166V17.25H6.70836C6.17864 17.25 5.75 17.6786 5.75 18.2084V42.1667C5.75 44.2808 7.46916 46 9.58336 46H36.4167C38.5308 46 40.25 44.2808 40.25 42.1666V18.2084C40.25 17.6786 39.8214 17.25 39.2916 17.25ZM25.8694 37.2693C25.8993 37.5397 25.8124 37.8111 25.6308 38.0142C25.4492 38.2173 25.189 38.3334 24.9167 38.3334H21.0834C20.811 38.3334 20.5509 38.2173 20.3693 38.0142C20.1877 37.8112 20.1007 37.5398 20.1307 37.2693L20.7352 31.8328C19.7535 31.1187 19.1667 29.9891 19.1667 28.75C19.1667 26.6359 20.8859 24.9166 23.0001 24.9166C25.1143 24.9166 26.8335 26.6358 26.8335 28.75C26.8335 29.9891 26.2467 31.1187 25.265 31.8328L25.8694 37.2693ZM30.6666 17.25H15.3334V13.4166C15.3334 9.18931 18.7727 5.75 23 5.75C27.2273 5.75 30.6666 9.18931 30.6666 13.4166V17.25Z",
    fill: "#5BA1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockBlue);
export default __webpack_public_path__ + "static/media/icon-lock-blue.e561857d2885f934e53d48b78b331b96.svg";
export { ForwardRef as ReactComponent };